import { writable } from 'svelte/store';

export const updateAvailable = writable(false);

export function initServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // new SW took control
    updateAvailable.set(false);
  });
  navigator.serviceWorker.getRegistration()
    .then((reg) => {
      if (!reg) return;
      reg.addEventListener('updatefound', () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener('statechange', () => {
          if (sw.state === 'installed' && navigator.serviceWorker.controller) {
            updateAvailable.set(true);
          }
        });
      });
    })
    .catch((error) => {
      console.error('Failed to get service worker registration:', error);
    });
}

export function applyUpdate() {
  navigator.serviceWorker.getRegistration()
    .then((reg) => {
      if (reg && reg.waiting) {
        reg.waiting.postMessage('SKIP_WAITING');
      } else {
        // Fallback: try to update
        reg?.update();
      }
    })
    .catch((error) => {
      console.error('Failed to apply service worker update:', error);
    });
}

